import React, { useEffect } from 'react';
import { Empty } from 'antd';
import { useSelector } from 'react-redux';
import { CardWrapper, CardTitleHeading } from './style';
import ExercicioSelect from './ExercicioSelect.component';
import VisualizarGridButton from './VisualizarGridButton.component';
import { AA_TEXT_ON_LIGHT } from '~/modules/Helper/contrast.helper';

function EmptyCardGrafico({
  id,
  titulo,
  valorLink,
  tamanho,
  corFonte,
  showEyeButton = false,
  showExercicioSelect,
}) {
  const { zoomFonte } = useSelector(state => state.configuration);

  useEffect(() => {}, [zoomFonte]);
  return (
    <CardWrapper
      title={<CardTitleHeading>{titulo}</CardTitleHeading>}
      extra={
        <>
          {showExercicioSelect && <ExercicioSelect id={id} />}
          {showEyeButton && (
            <VisualizarGridButton to={valorLink} corFonte={corFonte} />
          )}
        </>
      }
      size="small"
      style={{
        height: '100%',
        fontSize: '25px',
      }}
    >
      <Empty
        description="Nenhum registro encontrado"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        style={{ margin: 0, color: AA_TEXT_ON_LIGHT }}
      />
    </CardWrapper>
  );
}

export default EmptyCardGrafico;
